import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import type {NutshellState} from '../../../../store';

import {ListProviderContext} from '../../entity-lists/list-provider-context';

import * as actions from './companies-actions';
import * as selectors from './companies-selectors';

type Props = {
    children: React.ReactNode;
};

export function CompaniesListProvider(props: Props) {
    const dispatch = useDispatch();

    const schema = useSelector((state: NutshellState) => selectors.getMcfxCompaniesSchema(state));
    const isFirstLoad = useSelector((state: NutshellState) =>
        selectors.getMcfxCompaniesListIsFirstLoad(state)
    );
    const isLoading = useSelector((state: NutshellState) =>
        selectors.getMcfxCompaniesListIsLoading(state)
    );
    const hasError = useSelector((state: NutshellState) =>
        selectors.getMcfxCompaniesListHasError(state)
    );
    const listItems = useSelector((state: NutshellState) =>
        selectors.getMcfxCompaniesListItems(state)
    );
    const count = useSelector((state: NutshellState) => selectors.getMcfxCompaniesListCount(state));
    const isFilterDrawerOpen = useSelector((state: NutshellState) =>
        selectors.getIsFilterDrawerOpen(state)
    );
    const fetchMcfxCompaniesSchema = () => dispatch(actions.requestMcfxCompaniesSchema());
    const fetchList = (
        filters: FilterObject[],
        pageNum: number,
        columns: string[],
        sort: string,
        q: string
    ) => dispatch(actions.requestMcfxCompaniesListData({filters, pageNum, columns, sort, q}));
    const toggleShowFilterDrawer = () => dispatch(actions.toggleShowFilterDrawer());

    return (
        <ListProviderContext.Provider
            // @ts-expect-error
            value={{
                schema,
                isFirstLoad,
                isLoading,
                hasError,
                listItems,
                count,
                isFilterDrawerOpen,
                fetchMcfxCompaniesSchema,
                fetchList,
                toggleShowFilterDrawer,
            }}
        >
            {props.children}
        </ListProviderContext.Provider>
    );
}
